module.exports = __webpack_public_path__ + "img/banner 拷贝.4ab2f980.png";